import React, {Component} from "react";
import {Tooltip, Drawer, Tabs, Progress} from "antd";
import {FlagOutlined} from "@ant-design/icons";
import {Operator, Pagination, Table} from "src/library/components";
import {fetch, post} from "src/utils/axios_utils";
import './index.less'
import DetailsModal from './details_modal'
const {TabPane} = Tabs;
export default class systemSetting extends Component {
    state = {
        visible: false,
        columns: [
            {
                title: '任务类型',
                dataIndex: 'scheduledEnums',
                width: 120,
                align: 'center',
                render: (text) => {
                    return <div> {text ? text.name : ''} </div>
                }
            },
            {
                title: '任务名称',
                dataIndex: 'name',
                align: 'center',
                render: (text) => {
                    return <div style={{textAlign: 'left'}}>{text}</div>
                }
            },
            {
                title: '进度',
                dataIndex: 'number',
                width: 150,
                align: 'center',
                render: (text, row) => {
                    let rate = ((row.completeNumber || 0) / text * 100).toFixed(0)
                    return <div>
                        <Progress percent={rate} size="small" />
                    </div>
                }
            },
            {
                title: '备注',
                dataIndex: 'remark',
                width: 150,
                align: 'center',
            },
        ],
        dataSource: [],
        tableBts: [
            {
                name: '详情',
                method: 'details',
                isShow: false
            },
            {
                name: '删除',
                method: 'delete',
                isShow: false
            }
        ],
        params: {
            pageNum: 1,         // 分页当前页
            pageSize: 20,       // 分页每页显示条数
            total: 0,
            status: '全部',
            allTotal: 0
        },
        loading: false,
        detailsVisible: false,
        taskStatusEnum: [],
        infoData: []
    }
    mySetInterval = '';
    componentDidMount() {
        // this.getPermissionByPath()
        // this.getTaskStatusEnum()
    }
    componentWillUnmount() {
        //清除定时器
        if (this.mySetInterval) {
            clearTimeout(this.mySetInterval);
        }
    }
    getAsyncTaskList() {
        console.log(1)
        if (this.state.loading) return;
        let {params} = this.state
        this.setState({loading: true});
        params = {
            page: params.pageNum - 1,
            size: params.pageSize,
            status: params.status === '全部' ? '' : params.status
        }
        fetch('/asyn/task/list', params)
            .then(res => {
                if (res.success) {
                    this.setState({
                        dataSource: res.data.content,
                        params: {
                            ...this.state.params,
                            total: res.data.totalElements
                        }
                    })
                }
            })
            .catch(err => {
                console.log(err);
            }).finally(() => this.setState({loading: false}));
    }

    getTaskStatusEnum() {
        fetch('/system/enum/get', {name: 'asyn.StatusEnums'})
            .then(res => {
                if (res.success) {
                    this.setState({taskStatusEnum: res.data}, () => {
                        this.getAsyncTaskList()
                    })
                }
            })
    }
    showDrawer = () => {
        this.props.history.push({pathname: '/asyn/task/list'});
        // this.setState({
        //     visible: true,
        // },()=> {
        //     this.mySetInterval = setInterval(()=> {
        //         this.getAsyncTaskList()
        //     }, 2000)
        // });
    };
    onClose = () => {
        this.setState({
            visible: false,
        },()=> {
            //清除定时器
            if (this.mySetInterval) {
                clearTimeout(this.mySetInterval);
            }
        });
    };

    getPermissionByPath() {
        let params = {
            route: '/asyn/task/list'
        };
        fetch('/system/permission/children', params).then(res => {
            if (res.success) {
                let tableBts = this.state.tableBts;
                for (let permission of res.data) {
                    for (let button of tableBts) {
                        if (permission.name === button.name) {
                            button.isShow = true;
                        }
                    }
                }
                this.setState({
                    tableBts
                }, () => {
                    this.setOperator()//设置table操作按钮
                })
            }
        }).catch(err => {
            console.log(err);
        })
    }
    setOperator = () => {
        let object = {
            title: '操作', dataIndex: 'operator', width: 60, align: 'center', fixed: 'right',
            render: (value, record) => {
                const {id} = record;
                let items = []
                this.state.tableBts.forEach(item => {
                    if (item.method === 'details') {
                        items.push({
                            label: item.name,
                            icon: 'file-search',
                            disabled: !item.isShow,
                            onClick:()=> {
                                this.setState({
                                    infoData: record.details,
                                    detailsVisible: true
                                })
                            }
                        })
                    } else if (item.method === 'delete') {
                        items.push({
                            label: item.name,
                            color: 'red',
                            icon: 'delete',
                            disabled: !item.isShow,
                            confirm: {
                                title: `您确定删除?`,
                                onConfirm: () => this.handleDelete(id),
                            },
                        })
                    }
                })
                return <Operator items={items}/>;
            }
        }
        let columns = this.state.columns
        columns.push(object)
        this.setState({columns})
    }
    handleDelete = (id) => {
        post('/asyn/task/delete', {id}, '删除成功')
            .then(res => {
                if (res.success) {
                    this.getAsyncTaskList()
                }
            })
    }
    activeKeyChange = (e) => {
        let {params} = this.state
        this.setState({
            params: {
                ...params,
                status: e
            }
        }, () => {
            this.getAsyncTaskList()
        })
    }

    render() {
        const {className} = this.props;
        let {loading, columns, dataSource, visible, params, taskStatusEnum, detailsVisible, infoData} = this.state
        return (
            <div>
                <div
                    className={className}
                    style={{
                        fontSize: 19,
                    }}
                >
                    <Tooltip placement="bottom" title={'异步任务'}>
                        <FlagOutlined onClick={this.showDrawer}/>
                    </Tooltip>
                    <Drawer
                        bodyStyle={{padding: 0}}
                        title="异步任务"
                        placement="right"
                        onClose={this.onClose}
                        visible={visible}
                        forceRender
                        width={'750px'}
                    >
                        <div className='data_export_div'>
                            <Tabs activeKey={params.status} onChange={this.activeKeyChange}>
                                <TabPane tab='全部' key="全部">
                                </TabPane>
                                {
                                    taskStatusEnum.map(item => {
                                        return <TabPane tab={`${item.label}`} key={item.value}>
                                        </TabPane>
                                    })
                                }
                            </Tabs>
                            <div className='fill_height_table'>
                                <Table
                                    // loading={loading}
                                    columns={columns}
                                    dataSource={dataSource}
                                    rowKey="id"
                                    serialNumber
                                    bordered
                                    pageNum={params.pageNum}
                                    pageSize={params.pageSize}
                                />
                            </div>
                            <Pagination
                                total={params.total}
                                pageNum={params.pageNum}
                                pageSize={params.pageSize}
                                onPageNumChange={pageNum => this.setState({
                                    params: {
                                        ...params,
                                        pageNum: pageNum
                                    }
                                }, () => this.getAsyncTaskList())}
                                onPageSizeChange={pageSize => this.setState({
                                    params: {
                                        ...params,
                                        pageSize: pageSize,
                                        pageNum: 1
                                    }
                                }, () => this.getAsyncTaskList())}
                            />
                        </div>
                        <DetailsModal
                            visible={detailsVisible}
                            titleName='详情信息'
                            width={1000}
                            infoData={infoData}
                            centered
                            onCancel={() => this.setState({detailsVisible: false})}
                        />
                    </Drawer>
                </div>
            </div>
        );
    }
}
